import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { DataTransactionParams } from "../../../definitions/api/shared/data-transaction-params";
import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { DataTransactionsState } from "../../models/shared/data-transactions-state";
import { AppState } from "../../reducers";
import { DataTransactionsSelectors } from "../../selectors/data-transactions.selectors";

@Injectable()
export class DataTransactionsGetMpAdminEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.dataTransactions.get),
			withLatestFrom(this.store.select(DataTransactionsSelectors.dataTransactions)),
			switchMap(([action, state]) =>
				DataTransactionsGetMpAdminEffects.canUseStoreValue(action, state)
					? of(MpAdminActions.dataTransactions.getSuccess(state))
					: of(MpAdminActions.dataTransactions.getApi({ params: action.params }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.dataTransactions.getApi),
			switchMap((action) =>
				this.mpAdminService.dataTransactions(action.params).pipe(
					map((transactions) =>
						MpAdminActions.dataTransactions.getSuccess({
							transactions,
							searchHistory: [action.params],
							loading: false
						})
					),
					catchError((error) =>
						of(MpAdminActions.dataTransactions.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private mpAdminService: MpAdminService
	) {}

	private static canUseStoreValue(action, state: DataTransactionsState): boolean {
		return (
			!_.has(state, "error") &&
			!state.loading &&
			!!_.find(_.get(state, "searchHistory", []), (params: DataTransactionParams) =>
				_.isEqual(params, action.params)
			)
		);
	}
}
